"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const GraphandFieldRelation_1 = __importDefault(require("../lib/fields/GraphandFieldRelation"));
const GraphandQuery_1 = __importDefault(require("../lib/GraphandQuery"));
const getPopulatedPaths_1 = require("./getPopulatedPaths");
const processPopulate_1 = __importDefault(require("./processPopulate"));
const _queries = {};
const _queryIds = {};
const _queryIdsTimeout = {};
const _handleRequestResult = async (Model, res, query) => {
    const populatedPaths = (0, getPopulatedPaths_1.getPopulatedPaths)(query.populate);
    if (populatedPaths === null || populatedPaths === void 0 ? void 0 : populatedPaths.length) {
        const populatedModels = [];
        const _processPath = (parentModel, path) => {
            const field = parentModel.fields[path];
            if (field instanceof GraphandFieldRelation_1.default) {
                const nextModel = Model._client.getModel(field.ref);
                populatedModels.push(nextModel);
                return nextModel;
            }
            return;
        };
        await Promise.all(populatedPaths.map(async (path) => {
            if (path.includes(".")) {
                _processPath(Model, path);
            }
            else {
                const paths = path.split(".");
                await paths.reduce(async (promise, currentPath) => {
                    const parentModel = await promise;
                    if (!parentModel) {
                        return;
                    }
                    return _processPath(parentModel, currentPath);
                }, Promise.resolve(Model));
            }
        }));
        await Promise.all(populatedModels.map((model) => model._init()));
    }
    if (populatedPaths === null || populatedPaths === void 0 ? void 0 : populatedPaths.length) {
        const fields = Model.getFields();
        res.rows.forEach((row) => (0, processPopulate_1.default)(row, fields, Model._client, populatedPaths));
    }
    Model.hydrate(res.rows, true);
};
const _request = async (Model, query, hooks, cacheKey, opts = {}) => {
    var _a, _b, _c, _d, _e;
    let axiosRes, res;
    try {
        const axiosOpts = opts.axiosOpts || {};
        // @ts-ignore
        axiosOpts.global = (_a = opts.global) !== null && _a !== void 0 ? _a : Model.isGlobal;
        let singleId, params;
        if (((_b = query === null || query === void 0 ? void 0 : query.ids) === null || _b === void 0 ? void 0 : _b.length) === 1 && !(query === null || query === void 0 ? void 0 : query.query)) {
            const { ids: [_id] } = query, _params = __rest(query, ["ids"]);
            singleId = _id;
            params = _params;
        }
        else if (!(query === null || query === void 0 ? void 0 : query.ids) && typeof ((_c = query === null || query === void 0 ? void 0 : query.query) === null || _c === void 0 ? void 0 : _c._id) === "string" && Object.keys(query.query).length === 1) {
            const { query: { _id } } = query, _params = __rest(query, ["query"]);
            singleId = _id;
            params = _params;
        }
        if (singleId) {
            const url = `${Model.baseUrl}/${singleId}`;
            axiosRes = await Model._client._axios.get(url, Object.assign(Object.assign({}, axiosOpts), { params }));
            res = { axiosRes, rows: [axiosRes.data.data], count: 1 };
        }
        else {
            const url = Model.queryUrl || `${Model.baseUrl}/query`;
            axiosRes = await Model._client._axios.post(url, query, axiosOpts);
            res = { axiosRes, rows: [], count: 0 };
            if ((_d = axiosRes.data.data) === null || _d === void 0 ? void 0 : _d.rows) {
                res.rows = axiosRes.data.data.rows;
                res.count = axiosRes.data.data.count;
            }
            else if ((_e = axiosRes.data.data) === null || _e === void 0 ? void 0 : _e._id) {
                res.rows = [axiosRes.data.data];
                res.count = 1;
            }
        }
        await _handleRequestResult(Model, res, query);
    }
    catch (e) {
        if (hooks) {
            await Model.execHook("postQuery", [query, null, e]);
        }
        throw e;
    }
    return res;
};
const fetchModel = async (Model, query, opts) => {
    var _a, _b;
    const modelKey = [(_b = (_a = Model._client) === null || _a === void 0 ? void 0 : _a._options) === null || _b === void 0 ? void 0 : _b.project, Model.scope].filter(Boolean).join(",");
    _queryIds[modelKey] = _queryIds[modelKey] || new Set();
    _queryIdsTimeout[modelKey] = _queryIdsTimeout[modelKey] || {};
    const queryIds = _queryIds[modelKey];
    const queryIdsTimeout = _queryIdsTimeout[modelKey];
    const mergeIds = async () => {
        var _a;
        if (Model._client._options.mergeQueries && query.isMergeable() && queryIds.size + query.ids.length < 100) {
            if (queryIdsTimeout) {
                clearTimeout(queryIdsTimeout);
            }
            query.ids.forEach(queryIds.add, queryIds);
            await new Promise((resolve) => setTimeout(resolve));
            query.ids = [...queryIds];
        }
        if (query.isMergeable() && ((_a = query.ids) === null || _a === void 0 ? void 0 : _a.length) === 1) {
            query = new GraphandQuery_1.default(query._model, { query: { _id: query.ids[0] } });
        }
    };
    const defaultOptions = {
        cache: true,
        hooks: true,
    };
    opts = Object.assign({}, defaultOptions, typeof opts === "object" ? opts : { cache: opts !== null && opts !== void 0 ? opts : defaultOptions.cache });
    const { cache, hooks } = opts;
    if (typeof query === "string") {
        query = new GraphandQuery_1.default(Model, { ids: [query] });
    }
    if (cache && query.isMergeable()) {
        await mergeIds();
    }
    // if (Model.translatable && !query.translations && Model._client._project?.locales?.length) {
    //   query.translations = Model._client._project?.locales;
    // }
    if (hooks) {
        await Model.execHook("preQuery", [query]);
    }
    let res;
    const cacheKey = Model.getCacheKey(query);
    if (cache) {
        res = Model._cache[cacheKey];
    }
    if (!res) {
        _queries[modelKey] = _queries[modelKey] || {};
        if (!_queries[modelKey][cacheKey]) {
            _queries[modelKey][cacheKey] = _request(Model, query, hooks, cacheKey, opts);
        }
        try {
            res = await _queries[modelKey][cacheKey];
        }
        catch (e) {
            delete _queries[modelKey][cacheKey];
            throw e;
        }
        if (hooks) {
            await Model.execHook("postQuery", [query, res]);
        }
    }
    Model._cache[cacheKey] = res;
    delete _queries[modelKey][cacheKey];
    _queryIdsTimeout[modelKey] = setTimeout(() => (_queryIds[modelKey] = new Set()));
    return res;
};
exports.default = fetchModel;
